<template>
  <div class="mana-layout">
    <the-header :bk="false" />
    <div class="container">
      <the-nav-menu class="nav-menu" />
      <div class="content-body">
        <router-view />
      </div>
      <span class="content-footer">技术支持：河南东方世纪交通科技股份有限公司</span>
    </div>
  </div>
</template>

<script>
import TheHeader from '@/components/TheHeader'
import TheNavMenu from '@/components/TheNavMenu'

export default {
  name: 'MapLayout',
  components: {
    TheHeader,
    TheNavMenu,
  },
}
</script>

<style lang="less" scoped>
.mana-layout {
  background-color: #ebeef0;

  .container {
    width: 1400px;
    margin: 0 auto;
  }

  .nav-menu,
  .content-body {
    float: left;
  }

  .content-body {
    width: 1210px;
    min-height: calc(~'100vh - 100px');
    // min-height: calc(~'100vh - 91px');

    &::after {
      display: block;
      content: '';
      width: 0;
      height: 0;
      visibility: hidden;
      clear: both;
    }
  }

  .content-footer {
    display: inline-block;
    position: relative;
    left: 50%;
    transform: translateX(-50%);
    text-align: center;
    color: #666;
    font-size: 14px;
    line-height: 40px;
  }
}
</style>
